import React, { useEffect, useRef } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useNode } from '@craftjs/core';

import SelectColor from '@resolvers/tools/SelectColor/SelectColor';

import SettingsWrapper from '@common/components/SettingsWrapper/SettingsWrapper';
import SettingsRow from '@common/components/SettingsWrapper/SettingsRow';
import { EDITOR_RESOLVERS } from '@common/constants';
import { TemplateConfigProvider } from './TemplateContext';
import HeaderFooter from '@resolvers/tools/HeaderFooter/HeaderFooter';

const TemplatePdf = ({ background, children, pageSize }) => {
  const {
    connectors: { connect, drag },
    actions: { setCustom },
    showHeader,
    showFooter,
  } = useNode((node) => ({
    showHeader: node.data.props.showHeader,
    showFooter: node.data.props.showFooter,
  }));

  const { t } = useTranslation();
  const ref = useRef(null);

  useEffect(() => {
    if (ref?.current && connect) {
      connect(drag(ref.current));
    }
  }, [connect]);

  useEffect(() => {
    setCustom((props) => {
      props.displayName = t('template');
    });
  }, [setCustom, t]);

  return (
    <TemplateConfigProvider
      showHeader={showHeader}
      showFooter={showFooter}
      pageSize={pageSize}
    >
      <div
        ref={ref}
        className='pdf-template'
        style={{
          width: 'fit-content',
          margin: 'auto',
          height: 'fit-content',
          backgroundColor: `${background}`,
          position: 'relative',
          zIndex: 1,
        }}
      >
        {children}
      </div>
    </TemplateConfigProvider>
  );
};

const TemplateConfigPanel = () => {
  return (
    <SettingsWrapper>
      <SettingsRow>{/* <HeaderFooter /> */}</SettingsRow>
      <SettingsRow>
        <SelectColor />
      </SettingsRow>
    </SettingsWrapper>
  );
};

export const TemplateDefaultProps = {
  background: '#ffffff',
  children: null,
  pageSize: {},
};

TemplatePdf.defaultProps = TemplateDefaultProps;

TemplatePdf.propTypes = {
  background: PropTypes.string,
  children: PropTypes.node,
};

TemplatePdf.craft = {
  displayName: EDITOR_RESOLVERS.PDF.TEMPLATE,
  name: EDITOR_RESOLVERS.PDF.TEMPLATE,
  props: TemplateDefaultProps,
  related: {
    settings: TemplateConfigPanel,
  },
  rules: {
    canMoveIn: (node) => {
      return node[0]?.data?.name !== EDITOR_RESOLVERS.PDF.GRID_CELL;
    },
  },
};

export default TemplatePdf;
